var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8261_28791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.86035 14.6925C4.50317 16.7372 5.85577 18.4848 7.67399 19.6198C9.49222 20.7547 11.6563 21.2023 13.7756 20.8818C15.8948 20.5612 17.8297 19.4936 19.2309 17.8716C20.6321 16.2497 21.4074 14.1803 21.4167 12.0369C21.426 9.89353 20.6688 7.81743 19.2817 6.18336C17.8947 4.54929 15.9692 3.46489 13.8527 3.12591C11.7363 2.78694 9.56846 3.21571 7.74043 4.33483C5.91241 5.45395 4.54467 7.1897 3.8841 9.22876",
    stroke: "url(#paint0_radial_8261_28791)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12H2.5",
    stroke: "url(#paint1_radial_8261_28791)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25L15.5 12L12 8.75",
    stroke: "url(#paint2_radial_8261_28791)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8261_28791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8234 25.691) rotate(-134.206) scale(36.8005 125.141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8261_28791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.763 13.262) rotate(-175.582) scale(19.0561 9.95807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8261_28791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3785 16.953) rotate(-118.195) scale(10.8266 30.6729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2AA0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8261_28791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.059a4540d46a0d962d787a0fb670ef42.svg";
export { ForwardRef as ReactComponent };